
export default function FactorySuccessSection() {
  const successCases = [
    {
      name: '福建春茗茶业有限公司',
      location: '福建省安溪县',
      specialty: '铁观音专业生产',
      cooperation: '战略合作伙伴',
      duration: '8年合作',
      achievement: {
        production: '年产能从200吨提升至1200吨',
        revenue: '年营收增长320%',
        market: '产品远销15个国家',
        certification: 'ISO9001、有机认证'
      },
      testimonial: '与南店古茶的合作让我们从小作坊发展成为现代化茶叶工厂，不仅产能大幅提升，品牌价值也得到了质的飞跃。',
      avatar: 'https://public.readdy.ai/ai/img_res/b5275112b7b4b91ea04eb01969c8f748.jpg',
      factoryImage: 'https://readdy.ai/api/search-image?query=Modern%20tea%20processing%20factory%20exterior%20view%2C%20large%20industrial%20building%20with%20company%20signage%2C%20professional%20tea%20manufacturing%20facility%2C%20clean%20industrial%20environment%2C%20successful%20tea%20business%20operation&width=400&height=250&seq=factory-01&orientation=landscape'
    },
    {
      name: '云南古树茶业集团',
      location: '云南省普洱市',
      specialty: '普洱茶深加工',
      cooperation: 'ODM产品开发',
      duration: '5年合作',
      achievement: {
        production: '新增3条现代化生产线',
        revenue: '合作产品占总收入60%',
        market: '开发12款爆款产品',
        certification: 'HACCP、绿色食品认证'
      },
      testimonial: '通过ODM合作模式，我们不仅提升了生产技术，更重要的是学会了如何开发符合市场需求的创新产品。',
      avatar: 'https://readdy.ai/api/search-image?query=Experienced%20tea%20industry%20executive%20portrait%2C%20professional%20Chinese%20businesswoman%2C%20tea%20plantation%20owner%2C%20confident%20industry%20leader%2C%20modern%20business%20attire%2C%20professional%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
      factoryImage: 'https://readdy.ai/api/search-image?query=Yunnan%20tea%20processing%20facility%20with%20traditional%20and%20modern%20equipment%2C%20tea%20workers%20processing%20Pu-erh%20tea%2C%20large-scale%20tea%20manufacturing%2C%20mountain%20region%20tea%20factory%2C%20professional%20tea%20production&width=400&height=250&seq=factory-02&orientation=landscape'
    },
    {
      name: '浙江龙井茶业股份公司',
      location: '浙江省杭州市',
      specialty: '绿茶精品加工',
      cooperation: 'OEM代工合作',
      duration: '3年合作',
      achievement: {
        production: '标准化程度提升80%',
        revenue: '代工订单稳定增长',
        market: '通过欧盟有机认证',
        certification: 'BRC、FDA认证'
      },
      testimonial: 'OEM合作让我们专注于生产工艺的提升，稳定的订单保障了工厂的健康发展，员工收入也有了明显提高。',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20tea%20factory%20manager%20portrait%2C%20professional%20Chinese%20businessman%2C%20modern%20tea%20industry%20leader%2C%20innovative%20entrepreneur%2C%20business%20suit%2C%20confident%20expression%2C%20contemporary%20office%20setting&width=100&height=100&seq=avatar-03&orientation=squarish',
      factoryImage: 'https://readdy.ai/api/search-image?query=Modern%20green%20tea%20processing%20facility%20in%20Hangzhou%2C%20automated%20tea%20production%20lines%2C%20workers%20in%20clean%20uniforms%2C%20quality%20control%20stations%2C%20professional%20Longjing%20tea%20manufacturing%20environment&width=400&height=250&seq=factory-03&orientation=landscape'
    }
  ];

  const statistics = [
    { number: '50+', label: '合作工厂', icon: 'ri-building-line' },
    { number: '5000吨+', label: '年产能', icon: 'ri-scales-line' },
    { number: '15年+', label: '平均合作时长', icon: 'ri-time-line' },
    { number: '98%', label: '工厂满意度', icon: 'ri-thumb-up-line' }
  ];

  return (
    <section id="success" className="py-20 bg-white">
      <div className="container mx-auto px-6 lg:px-16 xl:px-24">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            成功案例
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            与我们合作的工厂都实现了跨越式发展，共同书写行业成功故事
          </p>
        </div>

        {/* Statistics */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          {statistics.map((stat, index) => (
            <div key={index} className="text-center bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="w-12 h-12 mx-auto mb-3 bg-blue-500 rounded-full flex items-center justify-center">
                <i className={`${stat.icon} text-white text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-bold text-blue-600 mb-1">{stat.number}</div>
              <div className="text-gray-700 font-medium text-sm md:text-base">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Success Cases */}
        <div className="space-y-12">
          {successCases.map((company, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-8 lg:p-12">
              <div className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-start gap-8 lg:gap-12`}>
                <div className="flex-1">
                  <img
                    src={company.factoryImage}
                    alt={company.name}
                    className="w-full h-64 object-cover rounded-xl shadow-lg mb-6"
                  />
                  
                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <h4 className="text-base md:text-lg font-bold text-gray-800 mb-4">合作成果</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <span className="text-xs md:text-sm text-gray-700">{company.achievement.production}</span>
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <span className="text-xs md:text-sm text-gray-700">{company.achievement.revenue}</span>
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <span className="text-xs md:text-sm text-gray-700">{company.achievement.market}</span>
                      </div>
                      <div className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <span className="text-xs md:text-sm text-gray-700">{company.achievement.certification}</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="flex-1 space-y-6">
                  <div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-2">{company.name}</h3>
                    <div className="flex flex-wrap gap-4 mb-4">
                      <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs md:text-sm">
                        <i className="ri-map-pin-line mr-1"></i>
                        {company.location}
                      </span>
                      <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs md:text-sm">
                        <i className="ri-leaf-line mr-1"></i>
                        {company.specialty}
                      </span>
                    </div>
                    <div className="flex flex-wrap gap-4 mb-6">
                      <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs md:text-sm font-medium">
                        <i className="ri-handshake-line mr-1"></i>
                        {company.cooperation}
                      </span>
                      <span className="inline-flex items-center px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs md:text-sm">
                        <i className="ri-time-line mr-1"></i>
                        {company.duration}
                      </span>
                    </div>
                  </div>
                  
                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <div className="flex items-start space-x-4">
                      <img
                        src={company.avatar}
                        alt="工厂负责人"
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      <div className="flex-1">
                        <div className="flex items-center mb-2">
                          <div className="flex text-blue-400">
                            {[...Array(5)].map((_, i) => (
                              <i key={i} className="ri-star-fill"></i>
                            ))}
                          </div>
                          <span className="ml-2 text-xs md:text-sm text-gray-600">工厂负责人评价</span>
                        </div>
                        <p className="text-gray-700 italic leading-relaxed text-xs md:text-sm">
                          "{company.testimonial}"
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Partner Network */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white text-center">
          <h3 className="text-xl md:text-2xl font-bold mb-6">合作伙伴网络</h3>
          <p className="text-blue-100 mb-8 max-w-3xl mx-auto text-sm md:text-base">
            我们的合作工厂遍布全国主要茶叶产区，形成了完善的供应链网络
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
            {[
              { region: '福建产区', count: '15家工厂', icon: 'ri-map-pin-2-line' },
              { region: '云南产区', count: '12家工厂', icon: 'ri-map-pin-2-line' },
              { region: '浙江产区', count: '8家工厂', icon: 'ri-map-pin-2-line' },
              { region: '安徽产区', count: '7家工厂', icon: 'ri-map-pin-2-line' },
              { region: '湖南产区', count: '8家工厂', icon: 'ri-map-pin-2-line' }
            ].map((region, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-4">
                <i className={`${region.icon} text-2xl mb-2 text-blue-400`}></i>
                <div className="font-bold text-sm md:text-base">{region.region}</div>
                <div className="text-blue-100 text-xs md:text-sm">{region.count}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
